import { render, staticRenderFns } from "./PopUpComponent.vue?vue&type=template&id=085cd656"
import script from "./PopUpComponent.vue?vue&type=script&lang=js"
export * from "./PopUpComponent.vue?vue&type=script&lang=js"
import style0 from "./PopUpComponent.vue?vue&type=style&index=0&id=085cd656&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports